import { IcoVehicleCar } from "assets/icons";
import { TravelItemProps } from "./types";

import styles from "./styles.module.scss";

export default function TravelItem({
	arrival,
	departure,
	paymentType,
	paymentDate,
	price
}: TravelItemProps) {
	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<div className={styles.travelIcon}>
					<IcoVehicleCar />
				</div>
				<div className={styles.travelInfo}>
					<span>
						{departure}/{arrival}
					</span>
					<span>
						Pagamento em {paymentType} em {paymentDate}
					</span>
				</div>
				<span className={styles.travelPrice}>{price}</span>
			</div>
		</div>
	);
}
